module.exports = "/assets/data/0a4d1fdc9ca7043d60e44490a72d259d-WD24.data.json";